import { FunctionComponent } from "react"
import clsx from "clsx"
import Link from "next/link"
import { useRouter } from "next/router"
import qs from "qs"
import ArrowLeft from "../svgs/feather-arrow-left.svg"
import ArrowRight from "../svgs/feather-arrow-right.svg"

type PaginationProps = {
  basePath?: string
  currentPage: number
  lastPage: number
  className?: string
}

const Pagination: FunctionComponent<PaginationProps> = ({
  basePath,
  currentPage,
  lastPage,
  className,
}) => {
  const router = useRouter()

  const getPageUrlForPage = (pageNumber: number) => {
    if (basePath) {
      if (pageNumber === 1) {
        return `/${basePath}`
      }
      return `/${basePath}/page/${pageNumber}`
    }

    return `${router.pathname}?${qs.stringify({
      ...router.query,
      page: pageNumber,
    })}`
  }

  const pageButtons = []

  for (let x = currentPage - 2; x <= currentPage + 2; x += 1) {
    if (x > 0 && x <= lastPage) {
      pageButtons.push(x)
    }
  }

  if (lastPage === 1) {
    return null
  }

  return (
    <nav
      className={clsx(
        "d-flex align-items-center justify-content-between",
        className,
      )}
    >
      <div
        className={clsx("page-item-arrow", {
          invisible: currentPage - 1 === 0,
        })}
      >
        <Link href={getPageUrlForPage(currentPage - 1)} className="page-link">
          <ArrowLeft />
        </Link>
      </div>
      <ul className="pagination justify-content-center">
        {pageButtons.map((item) => (
          <li
            className={clsx("page-item", { active: currentPage === item })}
            key={item}
          >
            <Link href={getPageUrlForPage(item)} className="page-link">
              {item}
            </Link>
          </li>
        ))}
      </ul>
      <div
        className={clsx("page-item-arrow", {
          invisible: currentPage === lastPage,
        })}
      >
        <Link href={getPageUrlForPage(currentPage + 1)} className="page-link">
          <ArrowRight />
        </Link>
      </div>
    </nav>
  )
}

export default Pagination
